// extracted by mini-css-extract-plugin
export default {"header":"StudyHeader_header__njn-W","backButton":"StudyHeader_backButton__i36a3","backIcon":"StudyHeader_backIcon__zy97r","title":"StudyHeader_title__UNaUt"};